<template>
  <transition name="modal">
    <div
      class="custom-modal"
      :id="getId"
      @click="handleOutsideClick($event)"
      v-if="showModal"
    >
      <transition name="modal-content">
        <div
          id="modal-content"
          :style="width && { width: width + '%' }"
          class="custom-modal-content"
        >
          <div v-if="showTitle"  class="modal-heading" :class="{ title: title }">
            <h1>{{ title }}</h1>
            <h1 v-if="showCancleBtn"  class="cursor-pointer" @click="closeModal">&#x2715;</h1>
          </div>
          <slot></slot>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    width: {
      type: String,
      required: false,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    showCancleBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  computed: {
    getId() {
      if (this.id) {
        return "modal-" + this.id;
      }
      return "modal";
    },
  },
  methods: {
    closeModal() {
      // alert(this.getId)
      this.$emit("close-modal", this.getId);
    },
    handleOutsideClick(event) {
      let modal = document.getElementById(this.getId);
      if (event.target == modal) {
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
.custom-modal {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease 0.5s;
  /* padding: 30% 0; */
}

/* Modal Content/Box */
.custom-modal-content {
  background-color: #ffffff;
  padding: 1.5rem;
  border: 1px solid #888;
  width: 70%;
  max-width: 800px;
  max-height: 90%;
  border-radius: 6px;
  overflow-y: scroll;
}
.custom-modal-content::-webkit-scrollbar {
  width: 0.1rem;
}
.custom-modal-content::-webkit-scrollbar-thumb {
  background-color: rgb(182, 182, 182);
  border-radius: 5px;
}
.modal-heading {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
}
.modal-heading.title {
  border-bottom: 0.2px solid #a3a4a7;
}
.modal-heading h1 {
  font-weight: bold;
  font-size: 1rem;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
.modal-enter-to,
.modal-leave {
  opacity: 1;
  transform: translateY(0);
}
.modal-enter-active,
.modal-leave-active {
  transition: all ease 0.5s;
}

@media screen and (max-width: 768px) {
  .custom-modal-content {
    width: 96% !important;
    padding: 0.5rem;
  }
}
</style>
